import { Component, OnInit } from "@angular/core";
import { BuyOffer } from "../entity/BuyOffer";
import { AuthService } from "../service/auth.service";
import { ValidationService } from "../service/validation.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { Router,ActivatedRoute } from "@angular/router";
import { AbstractBuyerComponent } from "./abstract/buyer.component";
import { KilowantContract } from "src/app/entity/KilowantContract";
import { Account } from "../entity/Account";
import { Utility } from "../entity/Utility";
import { DatePipe, CurrencyPipe } from "@angular/common";
import { UntypedFormControl } from "@angular/forms";
import { LegendPosition } from "@swimlane/ngx-charts";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ConfirmationDialog } from "./incs/confirmation-dialog.component";
import { Subscription } from "rxjs";
import { HeaderComponent } from "./incs/header.component";
import { AccountsListingComponent } from "./incs/accounts-listing.component";
import { FormatTimePipe } from "../pipes/format-time/format-time.pipe";

export interface Offer {
  position: number;
  type: string;
  price: number;
  startDate: Date;
  termPeriod: number;
  obj: object;
}
@Component({
    selector: "kilowant-buy-offer-details",
    templateUrl: "../../html/buyoffer-details.component.html",
    imports: [HeaderComponent, AccountsListingComponent, CurrencyPipe, DatePipe, FormatTimePipe]
})

export class BuyOfferDetailsComponent extends AbstractBuyerComponent {
  offers: Offer[] = [];
  displayedColumns: string[] = [];
  verificationPhase: boolean = false;
  offer: BuyOffer | null = null;
  companyName:any;
  relatedContract: KilowantContract = null!;
  countDown: Subscription;
  counter = 14400;
  tick = 1000;
  accounts: Account[] = null!;
  account: Account = null!;
  utilities: Utility[] = [];
  newUtilities: any = []
  utility: Utility = null!;
  dialogRef: MatDialogRef<ConfirmationDialog> = null!;
  flag = true;

  multi: any[] = [];
  view: [number, number] = [295, 295];
  legend: boolean = true;
  legendTitle: string = "";
  legendPosition: LegendPosition = null!;
  showLabels: boolean = true;
  animations: boolean = true;
  accountOffers = new UntypedFormControl();
  offerId:any;
  id: number = 0;
  newDate:any;
  newTime:any;
  filterOffer:any;
  viewAccounts: boolean = false;
  disabledButtons: string = "";

  constructor(
    router: Router,
    route: ActivatedRoute,
    authService: AuthService,
    analyticsService: AnalyticsService,
    generalService: GeneralService,
    public validationService: ValidationService,
    private datepipe: DatePipe,
    dialog: MatDialog
  ) {
    super(router, route, dialog, authService, analyticsService, generalService);
  }

   ngOnInit(): void {
    if (this.route.snapshot.paramMap.get("id") != null) {
      this.offerId = Number(this.route.snapshot.paramMap.get("id"));
    }
    this.refresh();
  }

  refresh(): void {
    this.generalService.getBuyOffer(this.offerId).then((ele) => {
      this.offer = ele.key;
      this.relatedContract = ele.value;
      if (this.relatedContract != null) {
        this.router.navigate(["/view-priceplan/" + this.relatedContract.id]);
      }
    });
  }
  
  editBuyOffer(buyOffer: BuyOffer): void {
    this.router.navigate(["/buy-order/details/" + buyOffer.id]);
  }
 
  cancel(){
     this.router.navigate(["user/home"]);
  }

  gotoEditOffer(id:any){
     this.router.navigate(["buy-offer/edit/" + id])
  }

  deleteBuyOffer(buyOffer: any): void {
   this.dialogRef = this.dialog.open(ConfirmationDialog, {
      disableClose: false
       , panelClass: "i-icon-popup"
   });
   this.dialogRef.componentInstance.confirmMessage = "Are you sure you want to delete this buyer offer?"
   this.dialogRef.afterClosed().subscribe(result => {
     if(result) {
       this.generalService.deleteBuyOffer(this.offerId)
           .subscribe((res:any) => {
                if (res) {
                   this.router.navigate(["user/home"]);
                }
            },           
            err => {
            });       
     }
     this.dialogRef = null!;
    });
   }
}
